import { useEffect, useRef, useState } from "react"
import { useFormContext } from "react-hook-form"
import Label from "../../common/form/label"
import Checkmark from "../../common/icons/checkmark"
import { useActiveStep } from "../store"
import InputGroup from "../../common/form/inputGroup"
import Button from "@/common/button/button"
import classNames from "classnames"
import getInputValidationClasses from "@/lib/helpers/getInputValidationClasses"
import { ErrorMessage } from "@/components/checkout-form/errorMessage"

const SLIDE_WIDTH = 272
const SLIDE_MARGIN = 24

function Motives() {
  const { templates, motives } = useActiveStep()
  const motivesRef = useRef()
  const { selectedMotive } = useFormContext()

  const templateIndex = templates.findIndex((template) => {
    return +template.id === +selectedMotive
  })

  useEffect(() => {
    motivesRef.current.scrollLeft = templateIndex
      ? SLIDE_WIDTH * templateIndex
      : 0
    setNumberOfMotive(
      motives.reduce((count, current) => count + current.motives.length, 0)
    )
    setValue("motive", motives[0].motives[0].id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [imageCategory, setImageCategory] = useState(0)
  const [numberOfMotiveToShow, setNumberOfMotiveToShow] = useState(4)
  const [numberOfMotive, setNumberOfMotive] = useState(100)

  const step = useActiveStep()
  let i = -1
  const { register, setValue, control } = useFormContext({
    defaultValues: {
      selectedArticle: 0
    }
  })

  return (
    <>
      <InputGroup>
        <Label name="selectedArticle" required={true}>
          Ändamål för din gåva
        </Label>
        <div className="relative">
          <select
            {...register("selectedArticle", {
              required: true,
              validate: (value) =>
                value !== "0" || "Välj ett ändamål för din gåva"
            })}
            id="article"
            className={classNames([
              getInputValidationClasses("selectedArticle", control),
              "block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline"
            ])}>
            <option value="0">Välj ändamål</option>
            {step.articles.map((article, index) => (
              <option key={index} value={article.articleId}>
                {article.name}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 top-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
            <svg
              className="w-4 h-4 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
        <ErrorMessage name="selectedArticle" />
      </InputGroup>
      <InputGroup>
        <Label name="greeting" required={true}>
          Välj motiv
        </Label>
        <div className="relative">
          <select
            onChange={(event) => {
              setImageCategory(event.target.value)

              if (event.target.value == 0) {
                setNumberOfMotive(
                  motives.reduce(
                    (count, current) => count + current.motives.length,
                    0
                  )
                )
                return
              }

              let currentCat = motives.find((item) => {
                return item.term_id == event.target.value
              })

              setValue("motive", currentCat.motives[0].id)

              setNumberOfMotiveToShow(4)
              setNumberOfMotive(currentCat.motives.length)
            }}
            id="article"
            className="block w-full py-2 pl-4 pr-8 text-lg leading-tight bg-white border rounded appearance-none border-black-50 focus:outline-none focus:shadow-outline">
            <option value={0}>Alla motiv</option>
            {motives.map((motiveCategory, index) => (
              <option key={index} value={motiveCategory.term_id}>
                {motiveCategory.name}
              </option>
            ))}
          </select>
          <div className="absolute inset-y-0 top-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
            <svg
              className="w-4 h-4 fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </InputGroup>

      <div className="flex flex-col w-full mb-6">
        <div
          className="flex space-x-4 overflow-x-scroll lg:gap-4 lg:space-x-0 lg:overflow-auto lg:grid lg:grid-cols-2"
          ref={motivesRef}
          style={{ scrollSnapType: "x mandatory", scrollBehavior: "smooth" }}>
          {motives.map((motive) => {
            if (imageCategory != 0) {
              if (motive.term_id != imageCategory) {
                return null
              }
            }

            return motive.motives.map((item) => {
              i++
              if (i < numberOfMotiveToShow) {
                return <Motive key={i} template={item} />
              }
            })
          })}
        </div>
        {numberOfMotive > numberOfMotiveToShow && (
          <Button
            theme="lime"
            ariaLabel="Visa flera"
            className="flex-grow mx-auto mt-10 md:flex-grow-0 align-center"
            onClick={() => {
              setNumberOfMotiveToShow(numberOfMotiveToShow + 2)
            }}>
            Visa flera
          </Button>
        )}
      </div>
    </>
  )
}

function Motive({ template }) {
  const { register } = useFormContext()
  const { selectedMotive } = useFormContext()
  const motiveRef = useRef()
  const { ref, ...rest } = register("motive")
  const isSelected = +template.id === +selectedMotive
  return (
    <label
      htmlFor={`motive-${template.id}`}
      className={`flex flex-col w-64 lg:w-auto flex-shrink-0 relative p-5 border rounded cursor-pointer ${
        isSelected ? "border-green-100" : ""
      }`}
      style={{ scrollSnapAlign: "start" }}>
      <input
        id={`motive-${template.id}`}
        type="radio"
        ref={(e) => {
          ref(e)
          motiveRef.current = e
        }}
        {...rest}
        defaultValue={template.id}
        onClick={() => {
          const { parentElement } = motiveRef.current
          parentElement.parentElement.scrollLeft =
            parentElement.offsetLeft - SLIDE_MARGIN
        }}
        className="absolute -z-1"
      />
      <div className="relative h-full" style={{ height: 200 }}>
        <img src={template.image.medium_large} key={template.id} />
      </div>
      <div className="flex items-center justify-center h-12">
        {isSelected ? (
          <div className="flex items-center justify-center text-white rounded-full bg-black-100 h-7 w-7">
            <Checkmark className="absolute w-4 h-4 text-white fill-current" />
          </div>
        ) : (
          <div className="border rounded-full h-7 w-7" />
        )}
      </div>
    </label>
  )
}
export default Motives
